module.exports = __webpack_public_path__ + "img/Shopee.2723e2e5.webp";